$.settings = {
  second_line: $('.textfield-wrapper.second-line'),
  add_section_text: $('.add-section-wrapper').find('span'),
  vehicle_year_array: null,
  vehicle_year_options: '',
  vehicle_year_select: $('select#vehicle_year'),
  on_year_change_empty_selects: $('select#vehicle_make, select#vehicle-model, select#vehicle-option'),
  vehicle_brand_options: '',
  vehicle_make_wrapper: $('.field-wrapper.brand-select-wrapper'),
  vehicle_make_select: $('select#vehicle_make'),
  on_brand_change_empty_selects: $('select#vehicle_model, select#vehicle-option'),
  vehicle_model_options: '',
  vehicle_model_wrapper: $('.field-wrapper.model-select-wrapper'),
  vehicle_model_select: $('select#vehicle_model'),
  on_model_change_empty_selects: $('select#vehicle-option'),
  vehicle_trim_options: '',
  vehicle_trim_wrapper: $('.field-wrapper.option-select-wrapper'),
  vehicle_trim_select: $('select#vehicle_trim')
}

$(document).ready(function() {
  // Call API and set Make dropdown options on page load
  $.ajax({ 
    type: 'GET', 
    url: '/a/tires/api/vehicle_makes', 
    success: function (data) {
      var items = [];
      items.push( "<option value='" + '' + "'>" + 'Sélectionner' + "</option>" );

      $.each( data.data.vehicle_makes, function( key, val ) {
        items.push( "<option value='" + val.id + "'>" + val.name + "</option>" );
      });

      $( "#vehicle_make").html(items.join( "" ));
    },
    error: function (err) {
      console.log('Error', err);
    }
  });
});


$(function() {
  if($('.slideshow-search-wrapper').length > 0) {
    //Get years range
    $.settings.vehicle_year_array = getYearRange(1980);
    $.settings.vehicle_year_array = $.settings.vehicle_year_array.reverse();

    //Build options list
    $.settings.vehicle_year_options += '<option value="">Choisir...</option>';    
    for (var i = 0; i < $.settings.vehicle_year_array.length; i++) {
      $.settings.vehicle_year_options += '<option value="' + $.settings.vehicle_year_array[i] + '">' + $.settings.vehicle_year_array[i] + '</option>';
    }

    //Append to select
    $('select#vehicle-year').append($.settings.vehicle_year_options);

    // Add rear tire inputs on click
    $('.add-section-wrapper').on('click', function(){    	      
      if($(this).hasClass('active')) {
        $.settings.second_line.removeClass('visible');
        $.settings.add_section_text.text('Ajouter une');
        $(this).removeClass('active');
      } else {
        $.settings.second_line.addClass('visible');
        $.settings.add_section_text.text('Retirer la');
        $(this).addClass('active');
      }
    });

    //Year select on change
    $.settings.vehicle_year_select.on('change', function(){
      if($(this).val() != ""){        
        $.ajax({ 
          type: 'GET', 
          url: '/a/tires/api/vehicle_trims', 
          data: {vehicle_year_id: $(this).val()},
          success: function (data) {

            var items = [];
            items.push( "<option value='" + '' + "'>" + 'Sélectionner' + "</option>" );
            $.each( data.data.vehicle_trims, function( key, val ) {
              items.push( "<option value='" + val.id + "'>" + val.name + "</option>" );
            });

            $( "#vehicle_trim").html(items.join( "" ));
          },
          error: function (err) {
            console.log('Error', err);
          }
        });
      }

    });

    // First tab By Dimension Select onChange event
    $('.tire-size-select').on('change', function(){
      // Remove error class
      $(this).parent().removeClass('errors');

      tire_size = $('#tire_width').val() + $('#tire_ratio').val() + 'R'+ $('#tire_diameter').val()
      $('.btn-search').attr('search-criteria', tire_size);
    });

    // Second tab By Vehicle Select onChange event
    $('section#content2 select').on('change', function(){
      // Remove error class
      $(this).parent().removeClass('errors');
    });

    //Brand select on change
    $.settings.vehicle_make_select.on('change', function(){
      if($(this).val() != ""){
        // Reset dropdowns
        $.settings.vehicle_trim_select.empty();
        $.settings.vehicle_year_select.empty();

        $.ajax({ 
          type: 'GET', 
          url: '/a/tires/api/vehicle_models', 
          data: {vehicle_make_id: $(this).val()},
          success: function (data) {

            var items = [];
            items.push( "<option value='" + '' + "'>" + 'Sélectionner' + "</option>" );
            $.each( data.data.vehicle_models, function( key, val ) {
              items.push( "<option value='" + val.id + "'>" + val.name + "</option>" );
            });

            $( "#vehicle_model").html(items.join( "" ));
          },
          error: function (err) {
            console.log('Error', err);
          }
        });
      }
    });

    //Model select on change
    $.settings.vehicle_model_select.on('change', function(){
      if($(this).val() != ""){
        // Reset dropdowns
        $.settings.vehicle_trim_select.empty();

        $.ajax({ 
          type: 'GET', 
          url: '/a/tires/api/vehicle_years', 
          data: {vehicle_model_id: $(this).val()},
          success: function (data) {

            var items = [];
            items.push( "<option value='" + '' + "'>" + 'Sélectionner' + "</option>" );
            $.each( data.data.vehicle_years, function( key, val ) {
              items.push( "<option value='" + val.id + "'>" + val.name + "</option>" );
            });

            $( "#vehicle_year").html(items.join( "" ));
          },
          error: function (err) {
            console.log('Error', err);
          }
        });
      }
    });

    // Search Btn on Click event
    $('.btn-search').on('click', function(e){
      if ($('#tab2').prop('checked')) {
        // Validate Tab selects field
        if (!validateTab($('section#content2'))) {
          $.ajax({ 
            type: 'GET', 
            url: '/a/tires/api/tires', 
            data: {vehicle_trim_id: $.settings.vehicle_trim_select.val()},
            success: function (data) {
              var items = [];
              $.each( data.data.tires, function( key, val ) {
                items.push( val.name );
              });

              // Check if results
              if (items.length > 0) {
                // Build tire list
                availableTiresBuilder(items);
              } else {
                // Display error message
                $('#tires-available-list').empty().append('<p>Aucun résultat retourné</p>');
              }

            },
            error: function (err) {
              console.log('Error', err);
            }
          });

          // Set modal details
          setModalDetails();
          // Show Modal
          showHideModal('open');
        }
      } else {
        // Validate Tab selects field
        if (!validateTab($('section#content1'))) {
          var tire_type = getSelectedTireType();
          
          if ($('.btn-search').attr('search-criteria') == undefined) {
          	getSearchCriteria();            
          }

          // launch search action
          window.location.href = '/collections/all/' + $('.btn-search').attr('search-criteria') + '+' + tire_type;
        }        
      }
    });

    // Close modal action
    $('#close-search-modal').on('click', function(){
      // Hide modal
      showHideModal('close');
      // Remove event listeners
      tireItemsRemoveClickEventListener();
    });

    // Check current radio button if it's label was clicked
    $('.radio-wrapper span.radio-label').on('click', function(){
      $(this).prev().click();
    });
  }
});

// Build year range
function getYearRange(startYear) {
  var currentYear = (new Date().getFullYear() + 1), years = [];
  startYear = startYear || 1980;

  while ( startYear <= currentYear ) {
    years.push(startYear++);
  } 

  return years;
}

//Fill appropriate Select tag with options from data
function fillSelectOptions(data, select, select_options, select_wrapper) {
  select.empty();
  select_options = '';

  select_options += '<option value="">Choisir...</option>';    
  for (var i = 0; i < data.length; i++) {
    select_options += '<option value="' + data[i] + '">' + data[i] + '</option>';
  }

  select.append(select_options);
  select.prop('disabled', false);
  select_wrapper.removeClass('disabled');
}

//Empty and reset appropriate select tags
function resetSelectOptions(selects) {
  selects.each(function(){
    if($(this).find('option').length > 0) {
      $(this).empty();
      $(this).append('<option value="">Choisir...</option>');
    }
  });
}

// Show or Hide modal event
function showHideModal(status) {
  if (status === 'open') {
    $('#modal-overlay').show().delay(500).queue(function(){
      $('#modal-overlay').css({opacity: 1});
      $('#search-modal').show();

      setTimeout(function(){
        $('#search-modal').addClass('open');
      }, 250);

      $.dequeue(this);
    });
  } else {
    $('#search-modal').removeClass('open').delay(500).queue(function(){
      $('#search-modal').hide();
      $('#modal-overlay').css({opacity: 0});

      setTimeout(function(){
        $('#modal-overlay').hide();
      }, 250);

      $.dequeue(this);
    });
  }
}

// Set all details from selected options
function setModalDetails() {
  var make = $('select#vehicle_make option:selected').html();
  var model = $('select#vehicle_model option:selected').html();
  var year = $('select#vehicle_year option:selected').html();
  var options = $('select#vehicle_trim option:selected').html();
  var search_modal_body = $('#search-modal .modal-wrapper .modal-body');

  search_modal_body.find('span#vehicle-make').html(make);
  search_modal_body.find('span#vehicle-model').html(model);
  search_modal_body.find('span#vehicle-year').html(year);
  search_modal_body.find('span#vehicle-trim').html(options);
}

// Build tire list
function availableTiresBuilder(items) {
  var html_str = '';
  var search_criteria = '';
  
  for(var i = 0; i < items.length ; i++) {
    search_criteria = items[i].replace('/', '').trim();
    html_str += '<div class="tire-item" search-criteria="' + search_criteria + '">' + items[i] + '</div>';
  }
  $('#tires-available-list').empty().append(html_str);

  // Add Click Event listeners to new element
  tireItemsAddClickEventListener();
}

// Add event listener to programmaticaly added elements
function tireItemsAddClickEventListener() {
  var children = document.getElementById('tires-available-list').children;

  for (let item of children) {
    item.addEventListener("click", launchSearch);
  }
}

// Remove event listener
function tireItemsRemoveClickEventListener() {
  var children = document.getElementById('tires-available-list').children;

  for (let item of children) {
    item.removeEventListener("click", launchSearch, true);
  }
}

// Launch Search on click
function launchSearch() {
  var tire_type = getSelectedTireType();
  window.location.href = '/collections/all/' + $(this).attr('search-criteria') + '+' + tire_type;
}

// Validate current tab and add error class on select elements
function validateTab(tab) {
  var errors_count = 0;
  var has_error = false;
  var tab_selects = $(tab).find('select');

  $(tab_selects).each(function(){
    if ($(this).val() === "" || $(this).val() === null) {
      $(this).parent().addClass('errors');
      errors_count++;
    }
  });

  if(errors_count > 0) {
    has_error = true;
  }

  return has_error;
}

// Get selected tire type input radio
function getSelectedTireType() {
  var radiocheckedval = '';

  $('.tire-type-wrapper input[type=radio]').each(function(){
    if ($(this).prop('checked') == true) {
      radiocheckedval = $(this).val();
    }
  });

  return radiocheckedval;
}

function getSearchCriteria() {
	var tire_size = $('#tire_width').val() + $('#tire_ratio').val() + 'R'+ $('#tire_diameter').val();
    $('.btn-search').attr('search-criteria', tire_size);
}